import api, { adminApiPrefix } from './Api';
import {
  OrderFilter,
  orderFilterToParams,
} from '../interfaces/Order/OrderFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { Order, orderFromResponse } from '../interfaces/Order/Order';
import { OrderStatus } from '../interfaces/Order/OrderStatus';
import {
  OrderStockHistory,
  orderStockHistoryFromResponse,
} from '../interfaces/Order/OrderStockHistory';
import { PartnerPlatform } from '../interfaces/PartnerPlatform/PartnerPlatform';
import {
  ProductToCollect,
  productToCollectFromResponse,
} from '../interfaces/ProductToCollect/ProductToCollect';

const orderAdminApiPrefix = `${adminApiPrefix}/order`;

export const getOrders = async (
  filter: OrderFilter,
): Promise<PaginatedResponse<Order>> => {
  const response = await api.get(orderAdminApiPrefix, {
    params: orderFilterToParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((order: any) =>
      orderFromResponse(order),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getOrdersByIDs = async (
  ids: number[],
): Promise<PaginatedResponse<Order>> => {
  const response = await api.get(orderAdminApiPrefix, {
    params: { ids },
    paramsSerializer: { indexes: null },
  });

  return {
    data: (response.data?.data ?? []).map((order: any) =>
      orderFromResponse(order),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getOrder = async (id: number): Promise<Order> => {
  const response = await api.get(orderAdminApiPrefix, {
    params: orderFilterToParams({
      id: id.toString(),
      pagination: { page: 0, pageSize: 1 },
    }),
  });

  const order = response.data?.data?.[0];
  if (!order) {
    throw new Error('Geçerli sipariş bulunamadı');
  }

  return orderFromResponse(order);
};

export const getOrderMessage = async (id: number): Promise<string> => {
  const response = await api.get(`${orderAdminApiPrefix}/message/${id}`);

  return response.data?.message ?? '';
};

export const getProductsToCollect = async (
  platform: PartnerPlatform,
  id: number,
): Promise<ProductToCollect[]> => {
  const response = await api.get(
    `${orderAdminApiPrefix}/products-to-collect/${platform}/${id}`,
  );

  return (response.data?.data ?? []).map((product: any) =>
    productToCollectFromResponse(product),
  );
};

export const getShippingBarcode = async (
  orderID: number,
): Promise<string | undefined> => {
  const response = await api.get(
    `${orderAdminApiPrefix}/shipment-barcode/${orderID}`,
  );

  return response?.data?.data;
};

export const getOrderStockHistory = async (
  orderID: number,
): Promise<OrderStockHistory[]> => {
  const response = await api.get(
    `${orderAdminApiPrefix}/stock-history/${orderID}`,
  );

  return (response.data?.data ?? []).map((stockHistory: any) =>
    orderStockHistoryFromResponse(stockHistory),
  );
};

export const updateOrderStatus = async (
  ids: number[],
  status: OrderStatus,
): Promise<void> => api.patch(orderAdminApiPrefix, { status, ids });
